// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import i18n from './i18n';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
// import 'bootstrap/dist/css/bootstrap.css';   
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'swiper/dist/css/swiper.css';
import 'vue2-animate/dist/vue2-animate.min.css';
import VModal from 'vue-js-modal';
import { VLazyImagePlugin } from "v-lazy-image";
import { DropdownPlugin, BootstrapVue } from 'bootstrap-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueGtag from "vue-gtag";
import VueMeta from 'vue-meta';
import Vuex from 'vuex';
import store from "./store/";
import "./assets/icons/index";
import $ from 'jquery';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faInfo)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;
Vue.use(DropdownPlugin);
Vue.use(BootstrapVue);
Vue.use(VLazyImagePlugin);
Vue.use(Vuex);
// Vue.use(VModal)
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMeta);
/* eslint-disable no-new */

// enables google tracking for myumyu
Vue.use(VueGtag, {
  config: { id: "UA-157716340-1" },
}, router);

new Vue({
  i18n,
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js